import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, inject, Injector, NgModule, provideAppInitializer, reflectComponentType, runInInjectionContext } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { BrowserModule } from '@angular/platform-browser';
import { CookieNotificationComponent } from '@shared-components/cookie-notification/cookie-notification.component';
import { TestSystemNotificationComponent } from '@shared-components/test-system-notification/test-system-notification.component';
import { TopNavigationComponent } from '@shared-components/top-navigation/top-navigation.component';
import { ModuleConfig } from '@shared-config/moduleConfig';
import { GenericErrorHandler } from '@shared-helpers/genericErrorHandler';
import { InitialiseService } from '@shared-services/initialise.service';
import cardValidator from 'card-validator';
import { CookieService } from 'ngx-cookie-service';
import { CallbackButtonComponent } from './components/callback-button/callback-button.component';
import { DatingModuleConfig } from './config/datingModuleConfig';

const components: any[] = [
  CookieNotificationComponent,
  TestSystemNotificationComponent,
  CallbackButtonComponent,
  TopNavigationComponent
];

@NgModule({
  //declarations: components,
  imports: [
    BrowserModule,
    components
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    { provide: ErrorHandler, useClass: GenericErrorHandler },
    { provide: ModuleConfig, useClass: DatingModuleConfig },
    provideAppInitializer(() => {
        const initializerFn = ((initialiseService: InitialiseService) => { return () => initialiseService.initialise(); })(inject(InitialiseService));
        return initializerFn();
      })
  ]
})
export class FourdModule {
  constructor(private injector: Injector) { }
  ngDoBootstrap() {
    for (const component of components) {
      const metadata = reflectComponentType(component);
      const htmlElement = createCustomElement(component, { injector: this.injector });
      customElements.define(metadata.selector, htmlElement);
    }

    // Expose selected code to whole page
    Object.defineProperty(globalThis, 'fourdHelper', {
      configurable: true,
      get: () => {
        return {
          cardValidator: cardValidator,
          cookieService: runInInjectionContext(this.injector, () => inject(CookieService))
        };
      }
    });
  }
}
